export default {
  title: 'Backup',

  general: {
    status: {
      all: 'All',
      saving: 'Saving',
      saved: 'Saved',
      retrieved: 'Retrieved'
    },

    notifications: {
      insert: {
        success: 'Creating the backup file succeed',
        error: 'Creating the backup file failed'
      },

      recovery: {
        success: 'Sending the request succeed',
        error: 'This backup is not recoverable',
        cantSend: 'Sending the request failed'
      }
    },

    confirmations: {
      insert: {
        title: 'Backup',
        body: 'Are you sure you want to create backup?'
      },

      recovery: {
        title: 'Backup',
        body: 'Are you sure you want to restore the backup?'
      }
    }
  },

  list: {
    table: {
      header: {
        rowNumber: 'Row',
        date: 'Date',
        status: 'Status',
        recovery: 'Recovery'
      }
    }
  }
}
